import classNames from 'classnames/bind';
import styles from "./styles.pcss";
export default classNames.bind(styles);